import { Formik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import { assignStaffToBranch, getActiveBranchesByCompanyId, removeStaffFromBranch } from '../../../../api/requests';
import Loader from '../../../../components/Loader';
import SelectDropdown, { ISelectDropdownItem } from '../../../../components/form-control/SelectDropdown';
import Button from '../../../../components/form-control/Button';
import useUserAccount from '../../../../hooks/userAccountHook';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import Input from '../../../../components/form-control/Input';
import { showToast } from '../../../../utils/miscFunctions';

const SetStaffToBranch = ({
  onProceed,
  onClose,
  staffId,
  isDeletion,
  branch,
  title
}: {
  onProceed: () => void;
  onClose: () => void;
  staffId: number;
  isDeletion: boolean;
  branch?: string;
  title: string;
}) => {
  const { user } = useUserAccount()
  const companyId = Number(user?.company?.id)
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [loadingData, setLoadingData] = useState<boolean>(true);
  const [branches, setBranches] = useState<any>([]);
  const addAction = !isDeletion && title === "ADD"
  const deleteAction = isDeletion && title === "DELETE"
  const queryClient = useQueryClient();

  useQuery({ queryKey: ['getBranchList'], queryFn: () => getBranchList() })

  const getBranchList = () => {
    getActiveBranchesByCompanyId(companyId)
      .then((response: any) => {
        setBranches(response?.data)
      })
      .catch((error: Error) => {
        console.log(error)
      })
      .finally(() => { setLoadingData(false) })

  }

  const submitHandler = (values: any) => {
    setSubmitting(true);
    if (addAction)
      assignStaffToBranch(staffId, values.id).then((response: any) => {
        onClose();
        showToast.success(response.message);
      }).catch((response: any) => {
        onClose();
        showToast.error(response.description);
      }).finally(() => { setSubmitting(false); queryClient.invalidateQueries({ queryKey: ['getAllCompanyStaff'] }) });

    if (deleteAction) {
      removeStaffFromBranch(staffId).then((response: any) => {
        onClose();
        showToast.success(response.message);
      }).catch((response: any) => {
        onClose();
        showToast.error(response.description);
      }).finally(() => { setSubmitting(false); queryClient.invalidateQueries({ queryKey: ['getAllCompanyStaff'] }) });
    }

  };
  return (
    <div className="bg-white rounded-xl dark:bg-darkBg">

      {loadingData ? (
        <div className="flex items-center justify-center  ">
          <Loader message={`Loading branches. Please wait...`} brollyLoaderFixed />
        </div>
      ) :
        (
          <>
            <div className="p-[1rem] flex items-start  mt-[26px] dark:text-darkBg-mainText">
              {/* <span className="">You are about to add a staff to branch.</span> */}
              {addAction ? <span className="">You are about to add a staff to branch.</span> : <span className="">You are about to remove a staff from branch.</span>}
            </div>
            <div className="p-[1rem] w-full">
              <Formik
                initialValues={{
                  id: ''
                }}
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object({
                  // email: Yup.string().email('Email provided invalid.').required('Email is requied.')
                })}
                onSubmit={(values) => {
                  submitHandler(values);
                }}>
                {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => (
                  <form className="space-y-4" onSubmit={handleSubmit}>
                    {addAction && <div className="">
                      <SelectDropdown
                        search={true}
                        label="Select branch"
                        name="id"
                        list={branches?.map((branch: any) => ({
                          name: `${branch.name}`,
                          value: branch.id
                        }))}
                        listSelectedValue={values.id}
                        onChange={(val: ISelectDropdownItem | null) => {
                          setFieldValue('id', val);
                        }}
                        onBlur={handleBlur}
                        placeholder="Select branch"
                        error={touched.id ? errors.id : undefined}
                        helperText={touched?.id ? errors.id : undefined}
                        required
                      />
                    </div>}

                    {deleteAction && <div>
                      <Input
                        type={'text'}
                        name="branch"
                        value={branch}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label="Staff's branch"
                        disabled
                        className="rounded"
                      />
                    </div>}

                    <div className="w-full flex gap-4 mt-6 !mb-4">
                      <Button
                        type="button"
                        label="Cancel"
                        onClick={onClose}
                        bgColor='secondary'
                        fullWidth

                      />
                      <Button
                        type="submit"
                        label="Submit"
                        bgColor='primary'
                        fullWidth
                        loading={submitting}
                        disabled={submitting}
                      />
                    </div>
                  </form>
                )}
              </Formik>
            </div>

          </>)}
    </div>
  );
};

export default SetStaffToBranch;
